/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
import React, { useContext, useState, useEffect } from 'react'
import { Link, navigate } from 'gatsby'
import Wishlist from '-!svg-react-loader!../../assets/images/wishlist-filled.svg';
import Image from '../image';
import AddToCartForm from '../add-to-cart-form';
import { StoreContext } from '../../context/store-context';
import ArrowIcon from '-!svg-react-loader!../../assets/images/icons/link-arrow.svg';
import { StaticImage } from 'gatsby-plugin-image';
import { useAccount } from '../../context/store-context';
import ProductContactButton from '../product-contact-button';
import { parseShopifyMetafields } from '../../utils/helpers';

const ProductItem = ({ data, variantId, quickView, midBanner, location, dataState, mainProduct }) => {
    const [wish, setWish] = useState(false)
    const { userIsAuthenticated, customerData } = useAccount();
    const parsingMetafields = data?.metafields ? parseShopifyMetafields(data?.metafields) : false;
    const metafields = data?.metafields ? data?.metafields : false;
    const hidingAddToCart = metafields ? metafields.find(metafield => metafield.namespace === 'hiding' && metafield.key === 'hidingAddToCart') : false;

    const {
        toggleWish,
        wishList
    } = useContext(StoreContext);

    useEffect(() => {
        wishList.forEach(el => {
            if (el === data.storefrontId) {
                setWish(true)
            }
        });
    }, [wishList, toggleWish, data.storefrontId])

    const handleWish = ()=> {
      if(typeof window !== 'undefined' && !userIsAuthenticated() && !customerData) {
        navigate('/account/login');
        return null;
      } else {
        toggleWish(data.storefrontId)
        setWish(!wish)
      }
    }

  const badge = data.badge?.value;
    const [newBadge, setNewBadge] = useState(false);

    const diffStartDate= new Date(data.createdAt);
    const diffEndDate = new Date();
    const oneDayCalc = 1000*60*60*24;
    const diffDate = Math.ceil((diffEndDate.getTime()-diffStartDate.getTime())/(oneDayCalc))

    useEffect(() => {
      if(diffDate <= 100) {
        return setNewBadge(true);
      }
    }, [newBadge, diffDate])

    const renderBadge = () => {
      if(badge) {
        return (
          <div className="Product__badge">{badge}</div>
        )
      } else if(newBadge) {
        return (
          <div className="Product__badge">New</div>
        )
      }
    }

    const locationCategory = location?.pathname && (location?.pathname).includes('/collection/') ? true : false;

    return (<>
        {midBanner && (
          <div className="Collection__products__banner">
            <div className="Collection__products__banner-l">
              <img src={midBanner.image.localFile.publicURL} alt={midBanner.image.altText} />
            </div>
            <div className="Collection__products__banner-r">
              <h4>{midBanner.title}</h4>
              <a target={midBanner.link.target} href={midBanner.link.url} title={midBanner.link.title}>{midBanner.link.title} <ArrowIcon /></a>
            </div>
          </div>
        )}
        <div className='Product' data-id={data.shopifyId}>
            <div className="Product__thumbnail">
                {
                  quickView === true &&
                  <div className="Home__Best__Sellers__Hover" >
                    <Link
                      to={`/product/${data.handle}`}
                      state={{prevPath: location?.pathname, ...dataState}}
                      className="Home__Best__Sellers__Hover__Link"
                    >
                      View product
                    </Link>
                  </div>
                }
                <Link
                  to={`/product/${data.handle}`}
                  state={{prevPath: location?.pathname, ...dataState}}
                  className="Product__thumbnail__link"
                >
                  {data.featuredImage ? (
                    <Image source={data.featuredImage} imgClass="Product__thumbnail__img" />
                  ) : (
                    <StaticImage
                      src="../../assets/images/scroll-logo.png"
                      className="Product__thumbnail__img Product__thumbnail__img--missing"
                      alt={' product thumbnail'}
                    />
                  )}
                </Link>

                {renderBadge()}

                <div className="Product__wishlist">
                    <Wishlist onClick={handleWish} className={`${wish ? 'wished' : ''}`} tabIndex={0} aria-label="add wishlist button" role="button"/>
                </div>
            </div>

            {data.vendor && data.vendor !== 'vendor-unknown' && (
                <small className='Product__brand'>{data.vendor}</small>
            )}

            <Link
              to={`/product/${data.handle}`}
              state={{prevPath: location?.pathname, ...dataState}}
              className="Product__name"
            >
              {location?.pathname === '/search/' ? (
                (parsingMetafields?.search?.searchTitle ?
                  `${parsingMetafields.search.searchTitle} - ${data.currentVarVal?.title}`
                  :
                  `${data.title}${data.currentVarVal?.title && data.currentVarVal?.title !== 'Default Title' && !['Rip Cut', 'Cross Cut', 'No Cut'].includes(data.currentVarVal?.title) ? ' - ' + data.currentVarVal?.title : ''}`
                  )
                ) : (
                  data.title
                )
              }

            </Link>

            {
              (!hidingAddToCart || hidingAddToCart?.value === "false") && (
                <AddToCartForm
                  product={data}
                  variantId={variantId}
                  productPage={true}
                  searchPage={location?.pathname === '/search/'}
                  mainProduct={mainProduct}
                  locationCategory={locationCategory}
                />
              )
            }
            {
              (hidingAddToCart && hidingAddToCart.value !== "false") && (
                <ProductContactButton product={data} page={true} metafields={metafields} />
              )
            }
        </div>
    </>)
}

export default ProductItem